document.addEventListener("turbolinks:load", function () {
  $medicineInput = $('*[data-behavior="autocomplete"]')
  $medicineDoseInput = $('*[data-behavior="autocomplete-dose"]')
  $allMedicineInput = $('*[data-behavior="autocomplete-all-medicine"]')
  var options = {
    url: function (phrase) {
      return "/medicines/search.json?medicine_name=" + phrase + "&medicine_unit=gram";
    },
    getValue: "name",
    template: {
      type: "description",
      fields: {
        description: "text"
      }
    },
  };

  var options_dose = {
    url: function (phrase) {
      return "/medicines/search.json?medicine_name=" + phrase + "&medicine_unit=dose";
    },
    getValue: "name",
    template: {
      type: "description",
      fields: {
        description: "text"
      }
    },
  };

  var options_all_medicine = {
    url: function (phrase) {
      return "/medicines/search.json?medicine_name=" + phrase + "&medicine_unit=all";
    },
    getValue: "name",
    template: {
      type: "description",
      fields: {
        description: "text"
      }
    },
  };

  $medicineInput.easyAutocomplete(options);
  $medicineDoseInput.easyAutocomplete(options_dose);
  $allMedicineInput.easyAutocomplete(options_all_medicine);

  // medicine index page tabs
  if (document.getElementById('gram_tab') && document.getElementById('dose_tab')) {
    const queryString = new URLSearchParams(window.location.search);
    const unit_param = queryString.get('unit')
    if (unit_param && unit_param == 'dose') {
      document.getElementById('gram_tab').classList.remove('active');
      document.getElementById('dose_tab').classList.add('active');
    } else {
      document.getElementById('dose_tab').classList.remove('active');
      document.getElementById('gram_tab').classList.add('active');
    }
  }
});


$(document).on('click', '#switch-medicine-mode, .add_fields', function () {
  setTimeout(function () {
    $medicineInput = $('*[data-behavior="autocomplete"]')
    $medicineDoseInput = $('*[data-behavior="autocomplete-dose"]')
    $allMedicineInput = $('*[data-behavior="autocomplete-all-medicine"]')
    var options = {
      url: function (phrase) {
        return "/medicines/search.json?medicine_name=" + phrase + "&medicine_unit=gram";
      },
      getValue: "name",
      template: {
        type: "description",
        fields: {
          description: "text"
        }
      },
    };

    var options_dose = {
      url: function (phrase) {
        return "/medicines/search.json?medicine_name=" + phrase + "&medicine_unit=dose";
      },
      getValue: "name",
      template: {
        type: "description",
        fields: {
          description: "text"
        }
      },
    };

    var options_all_medicine = {
      url: function (phrase) {
        return "/medicines/search.json?medicine_name=" + phrase + "&medicine_unit=all";
      },
      getValue: "name",
      template: {
        type: "description",
        fields: {
          description: "text"
        }
      },
    };

    $medicineInput.easyAutocomplete(options);
    $medicineDoseInput.easyAutocomplete(options_dose);
    $allMedicineInput.easyAutocomplete(options_all_medicine);
  }, 10);
});

$(document).on('click', '.add_fields', function () {
  setTimeout(function () {
    document.getElementById('switch-medicine-mode').click();
    document.getElementById('switch-medicine-mode').click();
  }, 10);
});

// Inventory adjustment hint
function inventory_adjustment_hint() {
  input = document.getElementById('inventory_adjustment_input');
  hint = document.getElementById('adjusted_medicine_inventory_hint');
  current_inventory = document.getElementById('current_inventory');
  console.log('input')
  if (!input || !hint || !current_inventory) {
    return
  }
  adjusted_value = (parseInt(input.value) || 0) + (parseInt(current_inventory.textContent) || 0);
  var hint_text = '<strong>调整后库存: ';
  hint_text += adjusted_value;
  hint_text += '</strong>';
  hint.innerHTML = hint_text;
}
$(document).on('change paste keyup',
  '#inventory_adjustment_input',
  inventory_adjustment_hint);


// collapisible content
$(document).on('click', '.collapsible, .collapsible-small', function () {
  this.classList.toggle("active");
  var content = this.nextElementSibling;
  if (content.style.maxHeight) {
    content.style.maxHeight = null;
  } else {
    content.style.maxHeight = content.scrollHeight + "px";
  }
});